import React from "react";
import { Activity } from "lucide-react";

const SimpleDashboard = () => {
  return (
    <div className="flex min-h-screen bg-[#F8F9FA] dark:bg-[#050A18] transition-colors duration-300">
      <div className="flex-1 flex flex-col">
        <main className="p-4 md:p-8 space-y-6 md:space-y-8 pb-24 lg:pb-8">
          
          {/* Header */}
          <div>
            <h1 className="text-2xl md:text-3xl font-black tracking-tight text-slate-800 dark:text-white transition-colors">
              Dashboard
            </h1>

            <p className="text-[10px] md:text-xs font-bold uppercase tracking-widest mt-1 text-slate-400 dark:text-slate-500">
              Home / Dashboard
            </p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="
                  bg-white dark:bg-[#0F172A]
                  border border-slate-100 dark:border-slate-800
                  shadow-sm
                  p-5 md:p-6
                  rounded-[1.5rem] md:rounded-[2rem]
                  flex items-center gap-4
                  transition-all duration-300
                  active:scale-95 lg:active:scale-100
                "
              >
                <div
                  className="
                    w-10 h-10 md:w-12 md:h-12
                    bg-orange-50 dark:bg-[#1E293B]
                    rounded-xl md:rounded-2xl
                    flex items-center justify-center
                    text-[#D4AF37]
                    shrink-0
                  "
                >
                  <Activity size={20} />
                </div>

                <div>
                  <p className="text-[9px] md:text-[10px] font-black uppercase tracking-widest text-slate-400 dark:text-slate-500">
                    Total Sales
                  </p>

                  <p className="text-lg md:text-xl font-black text-slate-800 dark:text-white">
                    $12,440
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Main Section */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8">
            
            {/* Transactions */}
            <div
              className="
                order-2 lg:order-1 lg:col-span-8
                bg-white dark:bg-[#0F172A]
                border border-slate-100 dark:border-slate-800
                shadow-sm
                rounded-[2rem] md:rounded-[2.5rem]
                p-6 md:p-8
                transition-colors duration-300
              "
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="font-black text-sm md:text-base text-slate-800 dark:text-white">
                  Recent Transactions
                </h2>

                <button
                  className="
                    text-[9px] md:text-[10px]
                    font-black uppercase tracking-widest
                    text-slate-400
                    hover:text-[#D4AF37]
                    dark:text-slate-500
                    dark:hover:text-[#D4AF37]
                    transition-colors
                  "
                >
                  View All
                </button>
              </div>

              <div className="w-full overflow-x-auto">
                <div
                  className="
                    min-w-[500px] lg:min-w-full
                    h-48
                    border-t border-slate-100 dark:border-slate-800
                    pt-4
                    text-xs md:text-sm italic
                    text-slate-400 dark:text-slate-500
                  "
                >
                  Table data according to customer name suggestion...
                </div>
              </div>
            </div>

            {/* Alerts */}
            <div
              className="
                order-1 lg:order-2 lg:col-span-4
                bg-white dark:bg-[#0F172A]
                border border-slate-100 dark:border-slate-800
                shadow-sm
                rounded-[2rem] md:rounded-[2.5rem]
                p-6 md:p-8
                transition-colors duration-300
              "
            >
              <h2 className="font-black mb-6 text-sm md:text-base text-slate-800 dark:text-white">
                Recent Alerts
              </h2>

              <div className="space-y-3 md:space-y-4">
                {[1, 2].map((alert) => (
                  <div
                    key={alert}
                    className="
                      flex items-center gap-4
                      p-3
                      rounded-2xl
                      border border-transparent
                      bg-slate-50 dark:bg-[#111827]
                      hover:border-orange-100 dark:hover:border-[#D4AF37]/20
                      transition-all
                    "
                  >
                    <div className="w-2 h-2 bg-[#D4AF37] rounded-full shrink-0"></div>

                    <p className="text-[11px] md:text-xs font-bold text-slate-600 dark:text-slate-300">
                      New QR Scan detected
                    </p>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </main>
      </div>
    </div>
  );
};

export default SimpleDashboard;